<script>
import { notify } from '@/helpers/notify' 

export default {
    name: 'SatisModal',
    props:[
        "data",
        "modelOpen"
    ],
    data() {
        return {
            form: {},
            submitted: false,
            tariffList:[]
        };
    }, 
    watch:{
        modelOpen(){
            this.form = {}
        },
        data(){
            this.getTariffList()
        }
    },
    methods: {
        close(){
            this.$parent.$bvModal.hide('speed_modal')
        },
        getTariffList(){
            this.$http.post('/tariff?output=one&fields=id,name,upload_limit,download_limit&groupBy=upload_limit,download_limit')
            .then(resp => {
                this.tariffList = resp.data
            })
        },
        handleSubmit(){
            this.$http.post(`/members/${this.data.id}/temporarily-speed`, { ...this.form} )
            .then(response => {
                if(response.data.error) return notify.error(response.data.message)
                notify.success(response.data.message)
                this.form = {}
                this.$parent.$bvModal.hide('speed_modal')
            })
        }
    },
};
</script>

<template>
<b-modal id="speed_modal"  title="Geçici Hız Tanımla"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
        <div class="mb-3">
            <label class="form-label d-block">Şuanki Tarifesi</label>
            <div>{{ data.tariff_name }}</div>
        </div>
        <div class="mb-3">
            <label class="form-label d-block">  
                <span>Yeni Hız</span>
                <span> ( M cinsinden sadece sayı giriniz. ) </span>
            </label>
            <div class="row">
                <div class="col-md-12">
                    <v-select 
                        v-model="form.tariff_id"
                        :options="tariffList"
                        :reduce="r => r.id"
                        label="name">
                        <template slot="option" slot-scope="option">
                            <div class="d-center">Upload (  {{ option.upload_limit }} Mbps ) - Download (  {{ option.download_limit }}  Mbps )</div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">{{ option.upload_limit }}M / {{ option.download_limit }}M</div>
                        </template>
                        <span slot="no-options">Sonuç Bulunamadı</span> 
                    </v-select>
                </div>
            </div>
        </div>
        <div class="mb-3">
            <label class="form-label d-block">  
                Hızı normale nezaman dönecek?
            </label>
            <div class="">
                <input id="upload" class="form-control" type="date"  v-model="form.expiredate">
            </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button 
                type="submit" 
                variant="success" 
                class="ms-1"
                >Kaydet
            </b-button>
        </div>
    </form>
</b-modal>
</template>